import { Pano } from "../Pano.js";
import { BaseControl, ControlPosition } from "./BaseControl.js";

export class ControlLookAt extends BaseControl {
    private _message: HTMLDivElement;

    constructor(pano: Pano) {
        super(pano, ControlPosition.RIGHT);

        this.element.classList.add("control-button", "look-at");
        this.element.innerHTML = `
        <div class="control-button-icon icon-492 play"></div>
        `;

        this.visible = false;

        this.pano.onChangeVideo.add((d) => {
            this.visible = d && d.look_at;
        });
        this.element.addEventListener("click", () => {
            var bounds = this.pano.viewContainer.getBoundingClientRect();
            var clientX = bounds.left + bounds.width * 0.5;
            var clientY = bounds.top + bounds.height * 0.5;
            var pos = this.pano.view.toPosition(clientX, clientY);
            this.pano.current.camera_x = pos.x;
            this.pano.current.camera_y = pos.y;
            this.pano.acfBridge.setCameraLookAt(pos.x, pos.y);
        });
    }
}